<template>

    <trax-ui-ajax-table-with-crud-actions 
        :id="id" :titles="titles" :props="props" :bus="bus" :actions="actions" duplicate="1" 
        :endpoint="endpoint">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: {
            bus: null,
            id: null,
            endpoint: null,
            editUrl: null,
        },

        data: function() {
            var titles = [
                lang.polaris.form.name,
                lang.polaris.form.status,
                ''
            ];
            var props = [
                {source: 'name'},
                {source: this.status }
            ];
            return {
                titles: titles,
                props: props,
                status_select: data.status_select,
                actions: [
                    {name: 'items', icon: 'toc', class: 'btn-default', url: this.editUrl}
                ]
            }
        },

        methods: {
        
            status(data, type, row, meta) {
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (row.status == 'active') color = 'success';
                else if (row.status == 'maintenance') color = 'warning';
                else if (row.status == 'archived') color = 'default';
                return '<span class="badge badge-'+color+'">'+label+'</span>';
            }
        }
    }
</script>
